module.exports = __webpack_public_path__ + "img/004.17e3c497.jpg";